export default "skymp5-front/5a3f0e79d9978644ef574b7656f38df2.jpg";